<template>
  <div class="chart-panel" style="margin: 2px">
    <div class="chart-header">
      <div class="panel-title" style="float: left;">{{ title }}</div>
      <el-button class="enlarge-btn" @click="enlargeEchart">详情</el-button>
<!--      <el-select v-model="value" placeholder="请选择" :popper-append-to-body="false" size="mini" class="chart-time-selector" @change="onTimeSelected">-->
<!--        <el-option-->
<!--                v-for="item in options"-->
<!--                :key="item.value"-->
<!--                :label="item.label"-->
<!--                :value="item.value">-->
<!--        </el-option>-->
<!--      </el-select>-->

<!--      <icon class="el-icon-zoom-in" style="color: white;"/>-->

<!--      <img src="../assets/enlargement.svg" alt="" @click="enlargeEchart" />-->
    </div>
    <div class="chart-container" >
      <lineEchart
        v-if="echartType == 'line'"
        :chartDataX="lineChartDataX"
        :chartDataY="lineChartDataY"
        style="width: 100%; height: 90%"
      ></lineEchart>

      <stackedLineEchart
        v-if="echartType == 'stackedLine'"
        :chartDataX="lineChartDataX"
        :chartDataY="lineChartDataY"
        :legendData="legendData"
        style="width: 100%; height: 90%"
      ></stackedLineEchart>

      <barEchart
        v-if="echartType == 'bar'"
        :chartDataX="lineChartDataX"
        :chartDataY="lineChartDataY"
        :SecondchartDataY="perDataY"
        style="width: 100%; height: 100%"
      ></barEchart>
    </div>

    <echartItemDialog ref="echartItemDialog"></echartItemDialog>
  </div>
</template>

<script>
import lineEchart from "../components/lineEchart.vue";
import echartItemDialog from "../components/echartItemDialog.vue";
import commonUtils from "../utils/common";
import stackedLineEchart from "../components/stackedLineEchart.vue";
import barEchart from "../components/barEchart.vue";

export default {
  components: { lineEchart, echartItemDialog, stackedLineEchart, barEchart },
  props: [
    "title",
    "sensorType",
    "lineChartDataX",
    "lineChartDataY",
    "echartType",
    "legendData",
    "perDataY",
  ],
  data() {
    return {
      options: [{
        value: 'last1h',
        label: '最近1小时'
      },{
        value: 'last12h',
        label: '最近12小时'
      },{
        value: 'last24h',
        label: '最近24小时'
      },{
        value: 'other',
        label: '自定义'
      }],
      value:'last1h'
    };
  },
  mounted() {},
  methods: {
    //放大图表
    enlargeEchart() {
      this.$refs.echartItemDialog.title = this.title;
      this.$refs.echartItemDialog.visible = true;
      this.$refs.echartItemDialog.lineChartDataX = this.lineChartDataX || [];
      this.$refs.echartItemDialog.lineChartDataY = this.lineChartDataY || [];
      this.$refs.echartItemDialog.perDataY = this.perDataY || [];
      this.$refs.echartItemDialog.legendData = this.legendData || [];
      this.$refs.echartItemDialog.echartType = this.echartType;
      this.$refs.echartItemDialog.curSensorData = this.getCurSensorDataByPositionOrSensorType()[0];

      this.$refs.echartItemDialog.curDataType = this.getDataTypeByTitle();

      //区分里程和其他的默认时间
      const num = this.getDataTypeByTitle() != 3 ? 1 : 24 * 7;
      this.$refs.echartItemDialog.dateValue = [
        commonUtils.timeFormat(
          new Date(new Date().getTime() - 3600 * num * 1000)
        ),
        commonUtils.timeFormat(new Date()),
      ];
      this.$refs.echartItemDialog.maxTime = commonUtils.timeFormat(new Date());
      this.$refs.echartItemDialog.minTime = commonUtils.timeFormat(
        new Date(new Date().getTime() - 3600 * num * 1000)
      );
      this.$refs.echartItemDialog.interval =
        this.getDataTypeByTitle() != 3 ? "1m" : "1d";
    },
    onTimeSelected(){
      this.$message.warning('功能开发中');
    },
    //根据图表名称获取dataType
    getDataTypeByTitle() {
      switch (this.title) {
        case "运行里程(公里)":
          return 3;
        case "运行速度(米/秒)":
          return 2;
        case "电梯倾角(度)":
          return 4;
        case "电机负载(ap)":
          return 1;
      }
    },
    //获取放大图表后，当前种类的传感器数据
    getCurSensorDataByPositionOrSensorType() {
      return this.$store.state.sensorClassificationList.filter((item) => {
        return item.sensorType == this.sensorType;
      });
    },
  },
  computed: {},
};
</script>

<style lang="less" scoped>

  /deep/ .el-input__inner{
    background-color: transparent;
    color: white;
    border-radius: 0px;
  }

  /deep/ .el-select-dropdown{
    background-color: rgb(14,24,41);
    border-radius: 0px;
    .selected{
      background-color: rgb(14,24,41);
    }
  }

  .el-select-dropdown__item{
    color: white;
  }

  .el-select-dropdown__item.hover{
    background-color: rgb(5,129,153);
  }

  .el-select-dropdown__item.selected{
    color: #409eff;
  }

.chart-panel {
  height: 100%;
  width: 100%;
}

.chart-header{
  height: 35px;

}

.chart-container{
  height: calc(100% - 35px);
}




.chart-time-selector{
  width: 120px;
  float: right;
  margin-right: 5px

}

.el-input--mini .el-input__inner{
  background-color: pink !important;
}

.enlarge-btn{
  height: 28px;
  padding: 0;
  width: 50px;
  float: right;
  border-radius: 0;
  background-color: transparent;
  color: white;
}

</style>



// WEBPACK FOOTER //
// src/components/echartItem.vue